import React from 'react'
import styled from 'styled-components'

import { useTranslation } from '../../i18n'
import { hk01LinkHandler } from '../../utils/commonUtils'
import { getColor, getFontSize } from '../../utils/cssUtils'

const TncWrapper = styled.p`
  color: ${getColor('lightGrey')};
  font-size: ${getFontSize('body1')};
  line-height: 1.67;
  margin-top: 16px;
  margin-bottom: 14px;
`

const DonationTnc = () => {
  const { t } = useTranslation('common')
  return (
    <TncWrapper
      dangerouslySetInnerHTML={{
        __html: t('enrollment.tnc', {
          tncLink: `${process.env.HK01_URL}/terms`
        })
      }}
      onClick={hk01LinkHandler}
    />
  )
}

export default DonationTnc
